import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import ace from 'ace-builds';
import { ElementsService, fullApiPath } from 'dbweb-core';
import { ThemeModel, ThemeService } from '../services/theme.service';
import { TaskState, TaslResultType } from './task';
import { TaskService } from './task.service';
import { Subscription } from 'rxjs';

@Component({
	selector: 'common-task',
	templateUrl: './task.component.html',
	styleUrls: ['./task.component.scss'],
	providers: [TaskState]
})
export class TaskComponent implements OnInit, OnDestroy {
	@HostBinding('class.task') hostClass = true;
	detailMode = false;
	IsMoreProgressUrl = false;
	moreEle: string;
	resultInfo: TaslResultType;

	themeModel: ThemeModel;
	options: any = { maxLines: 20, printMargin: false };
	subs: Subscription[] = [];
	constructor(
		private theme: ThemeService,
		private tservice: TaskService,
		private eles: ElementsService,
		private router: Router,
		public taskState: TaskState
	) {
		this.subs.push(
			this.theme.theme.subscribe(v => {
				this.themeModel = v.model;
			})
		);
	}
	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
		this.tservice.GetTaskMessage().subscribe(n => {
			this.resultInfo = n;
			if (this.resultInfo.MoreProgressURL !== '') {
				this.eles.setURLSign(this.resultInfo.MoreProgressURL, this.resultInfo.MoreProgressURLSign);
				this.IsMoreProgressUrl = true;
			}
			if (this.resultInfo.ZipFileURL !== '') {
				this.resultInfo.ZipFileURL = fullApiPath(this.resultInfo.ZipFileURL);
			}
		});
	}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
	moreProgressClick(event: MouseEvent) {
		this.router.navigateByUrl(this.resultInfo.MoreProgressURL);
	}
}
